module.exports = __webpack_public_path__ + "static/img/business81.99b56da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business81.png
// module id = FXTn
// module chunks = 9